define([
  "marionette",
  "messaging/messenger",
  "./landlordUsersView",
  "modules/admin/userAdministration/userList/userListModule",
  "modules/admin/userAdministration/userDetails/userDetailsModalModule",
  "modules/admin/userAdministration/usersModel",
], function (Marionette, Messenger, LandlordUsersView, UserListModule, UserDetailsModalModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "landlordUsers";
      this.region = options.region;
      this.landlord = options.model;
      this._setUpVents();
    },
    show: function () {
      // Must be of type UsersModel.allUsers or similar, implementing addNewUser()
      this.landlordUsers = Messenger.reqres.request(
        "landlord:users",
        this.landlord.get("landlordId"),
      );

      this.view = new LandlordUsersView.landlordUsersView();
      this.landlordUsersList = this.addSubModule(
        new UserListModule({ region: this.view.landlordUsersList, namespace: "landlordUsers" }),
      );

      this.view.on(
        "add:user",
        function () {
          const user = this.landlordUsers.addNewUser();
          user.set("landlordId", this.landlord.get("landlordId"));
          user.set("showPassword", true);
          Messenger.vent.trigger("show:modal", UserDetailsModalModule, {}, user, {
            title: "User Details",
            closeButton: false,
            closeOnBackgroundClick: false,
            modalWidth: "900px",
            trackInteraction: {
              action: "Add Landlord User",
              object: "User",
            },
          });
        },
        this,
      );

      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _showSubViews: function () {
      this.landlordUsers.onSynced(function () {
        this.landlordUsersList.show(this.landlordUsers);
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:landlord:profile:users",
        function () {
          this.show();
        },
        this,
      );
    },
  });
});
